const IMPORTS = import.meta.glob<string>(
  "../../node_modules/flag-icons/flags/1x1/*.svg",
  {
    eager: true,
    query: "?url",
    exhaustive: true,
    import: "default",
  },
);

const FLAGS = Object.fromEntries(
  Object.entries(IMPORTS).map(([path, url]) => {
    const filename = path.split("/").at(-1)!;
    return [filename.split(".")[0], url] as const;
  }),
);

export default function Flag({
  country,
  ...props
}: Omit<React.ComponentProps<"img">, "src"> & { country?: string }) {
  country = country?.toLowerCase();
  if (!country || !FLAGS[country]) {
    country = "un";
  }
  return <img src={FLAGS[country]} alt={country.toUpperCase()} {...props} />;
}
